<div class="chat">
  @if (!(chat && chat.id) || chatService.isLoaderChat.center) {
    <div class="container-center">
      @if (!chatService.isLoaderChat.center) {
        <span class="center-message">
          {{ 'select_chat' | translate }}
        </span>
      } @else {
        <app-loader />
      }
    </div>
  }

  @if (chat && chat.id && !chatService.isLoaderChat.center) {
    <div id="chat-box" class="w-100 d-flex flex-column">
      <div class="chat-header">
        <!-- Search Container -->
        @if (isResultContainer && chatService.chatSearchInfo.items) {
          <div class="block-search crm-scroll" (scroll)="onSearchScroll($event)" (mousedown)="$event.preventDefault()">
            @for (item of chatService.chatSearchInfo.items; let i = $index; track item.id) {
              <div
                class="block-search-item"
                tabindex="0"
                [ngClass]="{ 'block-search-item-selected': chatService.chatSearchInfo.selected_number === i }"
                (click)="selectSearchMessage(item.id, i)"
                matRipple
              >
                @if (item.created_by) {
                  <app-avatar
                    size="42px"
                    [url]="$safeNavigationMigration(baseService.currentUserInfo?.avatar_url)"
                    [isPhotoGallery]="false"
                  />
                } @else {
                  <app-avatar
                    size="42px"
                    [title]="chat.title"
                    [isBlocked]="chat.is_blocked"
                    [mediaId]="$safeNavigationMigration(chat.x_data?.photo_id)"
                    [chatId]="chat.id"
                    [url]="chat.logo_url"
                    [isPhotoGallery]="false"
                    [isGroup]="chat.sub_type === CHAT_SUB_TYPES.GROUP"
                  />
                }
                <div class="item-user-wrapper">
                  <span class="user-name-wrapper">
                    @if (!item.created_by) {
                      <span class="user-name text-truncate">
                        {{ chat.title }}
                      </span>
                    } @else {
                      <span class="user-name text-truncate">
                        {{ 'you' | translate }}
                      </span>
                    }

                    @if (item.created_at) {
                      @if (isToday(item.created_at)) {
                        <span class="item-message-date">
                          {{ item.created_at | date: 'HH:mm' }}
                        </span>
                      } @else if (isYesterday(item.created_at)) {
                        <span class="item-message-date">
                          {{ 'yesterday' | translate }}
                        </span>
                      } @else if (isCurrentWeek(item.created_at)) {
                        <span class="item-message-date">
                          {{ item.created_at | date: 'EE' }}
                        </span>
                      } @else {
                        <span class="item-message-date">
                          {{ item.created_at | date: 'dd.MM.yy' }}
                        </span>
                      }
                    }
                  </span>

                  @if (item.text) {
                    <span
                      class="item-message text-truncate"
                      [innerHTML]="item.text | highlight: chatService.chatSearchInfo.search_text | safeHtml"
                    >
                    </span>
                  }
                </div>
              </div>
            }

            @if (!(chatService.chatSearchInfo.items && chatService.chatSearchInfo.items.length)) {
              <app-no-results [wrap]="true" [text]="chatService.chatSearchInfo.search_text" />
            }
          </div>
        }

        <!-- Mobile Arrow Back To Chat List -->
        @if (baseService.isMobile && !chatService.chatPinnedInfo.visible && !chatService.chatDelayedInfo.visible) {
          <app-button btnType="icon" class="back-btn" (onChangeClick)="chatService.closeChat()">
            <app-icon>arrow_back</app-icon>
          </app-button>
        }

        <!-- Profile Picture -->
        @if (
          (!baseService.isMobile || (baseService.isMobile && !chatService.chatSearchInfo.search_visible)) &&
          !chatService.chatPinnedInfo.visible &&
          !chatService.chatDelayedInfo.visible
        ) {
          <div class="relative">
            <app-avatar
              [size]="baseService.isMobile ? '48px' : '54px'"
              [title]="chat.title"
              [isBlocked]="chat.is_blocked"
              [mediaId]="$safeNavigationMigration(chat.x_data?.photo_id)"
              [chatId]="chat.id"
              [url]="chat.logo_url"
              [isGroup]="chat.sub_type === CHAT_SUB_TYPES.GROUP"
              [additionalUrl]="entityIcons[chat.external_type]"
            />
            @if (chat.assigned_user) {
              <app-avatar
                class="absolute -left-1 top-1 z-10 h-[22px] w-[22px] rounded-full shadow-sm"
                size="22px"
                [title]="chat.assigned_user.name"
                [url]="chat.assigned_user.avatar_url"
                [isPhotoGallery]="false"
                [matTooltip]="chat.assigned_user.name"
                matTooltipPosition="above"
              />
            }
          </div>
        }

        <!-- Profile Title And Clip -->
        @if (
          !chatService.chatSearchInfo.search_visible &&
          !chatService.chatPinnedInfo.visible &&
          !chatService.chatDelayedInfo.visible
        ) {
          @if (!chatService.chatSearchInfo.search_visible) {
            <div class="chat-title">
              <div
                class="flex min-w-0 gap-2"
                [ngClass]="
                  baseService.isMobile ? 'flex-col items-start gap-0.5!' : 'flex-row items-center'
                "
              >
                <span
                  class="min-w-0 max-w-full flex-1 truncate"
                  [ngClass]="baseService.isMobile ? 'text-sm! leading-4!' : ''"
                  >{{ chat.title }}</span
                >
                <div
                  class="flex min-w-0 max-w-full shrink items-center overflow-hidden"
                  [ngClass]="baseService.isMobile ? 'gap-1.5' : 'gap-2'"
                >
                  @for (channel of chat.channels || []; track channel.id) {
                    <span
                      class="user-clip badge min-w-0 truncate"
                      [ngClass]="
                        baseService.isMobile
                          ? 'px-1.5! py-0.5! text-[10px]! font-medium! leading-4!'
                          : ''
                      "
                      >{{ channel.name }}</span
                    >
                  }
                </div>
              </div>
              <app-tags
                class="block max-w-[260px] leading-none"
                [ngClass]="baseService.isMobile ? 'mt-0.5' : ''"
                [tags]="chat.tags || []"
                [compact]="true"
              />
              @if (chat.x_data?.is_bot) {
                <span class="chat-subtitle text-secondary">{{ 'bot' | translate }}</span>
              }
              @if (chat.sub_type === CHAT_SUB_TYPES.GROUP) {
                <span class="chat-subtitle text-secondary">{{ 'group' | translate }}</span>
              }
            </div>
          }
        }

        <!-- Pinned Header -->
        @if (chatService.chatPinnedInfo.visible) {
          <app-button btnType="icon" (onChangeClick)="togglePinned()">
            <app-icon>arrow_back</app-icon>
          </app-button>
          <span class="additional-header-title">
            {{ 'pinned_header' | translate: { count: chatService.chatPinnedInfo.items.length } }}
          </span>
        }

        <!-- Delayed Header -->
        @if (chatService.chatDelayedInfo.visible) {
          <app-button btnType="icon" (onChangeClick)="toggleDelayed()">
            <app-icon>arrow_back</app-icon>
          </app-button>
          <span class="additional-header-title">
            {{ 'delayed_header' | translate: { count: chatService.chatDelayedInfo.items.length } }}
          </span>
        }

        <div class="flex-fill"></div>

        <!-- Search -->
        @if (chatService.chatSearchInfo.search_visible) {
          <app-search
            class="w-100"
            searchType="chats"
            [clearVisibility]="true"
            [loading]="chatService.chatSearchInfo.loading"
            (onClearChange)="toggleSearch()"
            (onValueChange)="onSearch($event)"
            (focusin)="onSearchFocusIn()"
            (focusout)="onSearchFocusOut()"
            [arrows]="!!chatService.chatSearchInfo.items?.length"
            (onArrowUpClick)="arrowSearch('up')"
            (onArrowDownClick)="arrowSearch('down')"
            [autoFocus]="true"
          />
        }

        <!-- Header Actions -->
        @if (
          !chatService.chatSearchInfo.search_visible &&
          !chatService.chatPinnedInfo.visible &&
          !chatService.chatDelayedInfo.visible
        ) {
          @if (!baseService.isMobile) {
            @for (item of menuButtonsDesktop; track $index) {
              @if (isMenuButtonVisible(item)) {
                <app-button (onChangeClick)="item.action()" btnType="icon" [attr.title]="item.title | translate">
                  <app-icon>{{ item.icon }}</app-icon>
                </app-button>
              }
            }
          }

          @if (baseService.isMobile) {
            <app-button btnType="icon" [cdkMenuTriggerFor]="chatMenu">
              <app-icon>more_vert</app-icon>
            </app-button>
          }
        }
      </div>

      @if (!OLD_RIA_CHAT_TYPES.includes(this.chat.external_type)) {
        <div
          class="overflow-hidden h-100 w-100 position-relative"
          [ngClass]="{ 'd-none': chatService.chatPinnedInfo.visible || chatService.chatDelayedInfo.visible }"
        >
          @if (!chatService.chatMessagesInfo.grouped_items.length || chatService.isLoaderChat.messages) {
            <div class="container-center">
              @if (!chatService.isLoaderChat.messages) {
                <span class="center-message">
                  {{ 'no_messages' | translate }}
                </span>
              } @else {
                <app-loader />
              }
            </div>
          }

          @if (chatService.isLoaderChat.down) {
            <app-loader type="indeterminate" />
          }

          @if (chatService.chatMessagesInfo.grouped_items.length && !chatService.isLoaderChat.messages) {
            <div
              #messageContainer
              [ngClass]="{ 'hidden-scroll': baseService.isMobile }"
              class="message-container crm-scroll"
              (scroll)="baseService.currentUserInfo?.settings?.is_lazy_loading && scrollTo($event)"
            >
              <div
                class="message-container-dragging"
                [ngClass]="{ 'message-container-dragging-show': isDragging }"
                (dragover)="onDragOver($event)"
                (dragleave)="onDragLeave($event)"
              ></div>

              <app-button
                [ngClass]="isBtnBottomShow() ? 'btn-bottom-show' : 'btn-bottom-hide'"
                (onChangeClick)="scrollBottom(chatService.chatMessagesInfo.total_first)"
                class="btn-bottom"
                btnType="icon"
              >
                <app-icon>arrow_downward</app-icon>
              </app-button>

              @if (
                !baseService.currentUserInfo?.settings?.is_lazy_loading &&
                !chatService.hasMessagesInfoItem(MESSAGES_INFO_POSITION.FIRST) &&
                !chatService.isLoaderChat.down &&
                !chatService.isLoaderChat.up
              ) {
                <div (click)="loadUpChats()" class="btn-loading click-css">{{ 'upload_more' | translate }}...</div>
              }

              <ng-container
                *ngTemplateOutlet="
                  groupsMessagesTemplate;
                  context: { groups: chatService.chatMessagesInfo.grouped_items }
                "
              />

              @if (
                !baseService.currentUserInfo?.settings?.is_lazy_loading &&
                !chatService.hasMessagesInfoItem(MESSAGES_INFO_POSITION.LAST) &&
                !chatService.isLoaderChat.down &&
                !chatService.isLoaderChat.up
              ) {
                <div (click)="loadDownChats()" matRipple class="btn-loading click-css">
                  {{ 'upload_more' | translate }}...
                </div>
              }

              @if (chatService.advert && chatService.hasMessagesInfoItem(MESSAGES_INFO_POSITION.LAST)) {
                <div class="chat-advert-info-container">
                  <chat-advert-info [advert]="chatService.advert" />
                </div>
              }
            </div>
          }

          @if (chatService.isLoaderChat.up) {
            <app-loader type="indeterminate" />
          }
        </div>
      }

      @if (chatService.chatPinnedInfo.visible) {
        <div [ngClass]="{ 'hidden-scroll': baseService.isMobile }" class="message-container crm-scroll gap-2 p-3">
          <ng-container
            *ngTemplateOutlet="
              groupsMessagesTemplate;
              context: {
                groups: chatService.chatPinnedInfo.grouped_items,
                isPinned: true,
              }
            "
          />
        </div>
      }

      @if (chatService.chatDelayedInfo.visible) {
        <div [ngClass]="{ 'hidden-scroll': baseService.isMobile }" class="message-container crm-scroll gap-2 p-3">
          <ng-container
            *ngTemplateOutlet="
              groupsMessagesTemplate;
              context: {
                groups: chatService.chatDelayedInfo.grouped_items,
                isDelayed: true,
              }
            "
          />
        </div>
      }

      @if (!chatService.chatPinnedInfo.visible && !chatService.chatDelayedInfo.visible) {
        @if (isCompanyPaused()) {
          <div class="flex items-center justify-center gap-2 border-t border-slate-200 bg-slate-50 px-4 py-3 text-sm font-medium text-slate-500">
            <app-icon class="!h-5 !w-5 !text-[20px] !leading-5 text-amber-500">lock</app-icon>
            {{ 'company_paused_cannot_write' | translate }}
          </div>
        } @else if (!hasConnectedChannel()) {
          <div class="flex items-center justify-center gap-2 border-t border-slate-200 bg-slate-50 px-4 py-3 text-sm font-medium text-slate-500">
            <app-icon class="!h-5 !w-5 !text-[20px] !leading-5 text-amber-500">link_off</app-icon>
            {{ 'channel_disconnected_cannot_write' | translate }}
          </div>
        }
      }

      @if (isShowUnassignedBlock()) {
        <div class="flex flex-col items-center gap-3 border-t border-slate-200 bg-slate-50 px-4 py-4">
          <div class="flex items-center gap-2 text-center text-sm font-medium text-slate-500">
            <app-icon class="!h-5 !w-5 !text-[20px] !leading-5 text-amber-500">person_off</app-icon>
            {{ 'chat_not_assigned' | translate }}
          </div>
          <div class="flex w-full flex-wrap items-center justify-center gap-2">
            <app-button [disabled]="isAssigningManager" (onChangeClick)="takeChat()">
              {{ 'take_chat' | translate }}
            </app-button>
            <app-button
              btnType="stroked"
              [disabled]="isAssigningManager"
              (onChangeClick)="toggleManagersPicker($event)"
            >
              {{ 'transfer_chat' | translate }}
            </app-button>
          </div>
        </div>

        <ng-template
          cdkConnectedOverlay
          [cdkConnectedOverlayOrigin]="managersPickerOrigin"
          [cdkConnectedOverlayOpen]="isManagersPickerOpen"
          [cdkConnectedOverlayPositions]="managersPickerPositions"
          [cdkConnectedOverlayPush]="true"
          [cdkConnectedOverlayViewportMargin]="8"
          [cdkConnectedOverlayHasBackdrop]="true"
          [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
          (backdropClick)="closeManagersPicker()"
          (detach)="closeManagersPicker()"
        >
          <div
            class="w-72 max-w-[calc(100vw-2rem)] overflow-hidden rounded-lg border border-slate-200 bg-white shadow-lg"
          >
            <div class="border-b border-slate-200 p-2">
              <div
                class="flex h-10 w-full items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 text-slate-500"
              >
                <span class="flex h-5 w-5 shrink-0 items-center justify-center" aria-hidden="true">
                  <app-icon [isFlexBox]="false" class="!text-[20px] !leading-5">search</app-icon>
                </span>
                <input
                  class="block h-full min-w-0 flex-1 border-0 bg-transparent text-base text-slate-800 outline-none placeholder:text-slate-400"
                  [(ngModel)]="managerSearchTerm"
                  [placeholder]="'search' | translate"
                  [attr.aria-label]="'search' | translate"
                />
              </div>
            </div>
            <div class="crm-scroll max-h-72 overflow-y-auto p-1">
              @if (!filteredManagers.length) {
                <span class="block p-3 text-center text-sm text-slate-500">{{ 'nothing_found' | translate }}</span>
              } @else {
                @for (manager of filteredManagers; track manager.id) {
                  <button
                    type="button"
                    class="flex min-h-10 w-full items-center gap-2.5 rounded-md px-2.5 text-left text-slate-800 transition-colors hover:bg-slate-100"
                    (click)="assignChatManager(manager.id)"
                  >
                    <app-avatar
                      size="24px"
                      [title]="manager.name"
                      [url]="manager.avatar_url"
                      [isPhotoGallery]="false"
                    />
                    <span class="min-w-0 flex-1 truncate">{{ manager.name }}</span>
                  </button>
                }
              }
            </div>
          </div>
        </ng-template>
      }

      @if (isShowInputContainer()) {
        <div class="input-container-wrapper">
          <div class="input-container">
            <div class="resizer" (mousedown)="onMouseDown($event)"></div>

            @if (messageAction.action !== SEND_ACTION_TYPE.SEND) {
              <div class="d-flex flex-column">
                <div class="action-description">
                  <span>{{ getActionDescription() }}</span>
                </div>
                <mat-divider></mat-divider>
                <div class="message-action-box p-2">
                  <app-icon>{{ getActionIcon() }}</app-icon>
                  <span class="text-truncate">{{ messageAction.actionText }}</span>
                  <div class="flex-fill"></div>
                  <app-icon class="cursor-pointer d-flex" (click)="resetInputContainer()">close</app-icon>
                </div>
                <mat-divider></mat-divider>
              </div>
            }

            @if (attachments.length) {
              <div class="files-list crm-scroll" [appPhotoGalleryGroup]="{ clickMode: 'single' }">
                @for (file of attachments; let i = $index; track i) {
                  <div class="file">
                    @if (file?.type === ATTACHMENTS_TYPES.IMAGE) {
                      <img
                        [appPhotoGallery]="{ mimeType: file.mimeType, url: file.url }"
                        [src]="file.url"
                        draggable="false"
                        class="click-css"
                        alt="file img"
                      />
                    } @else {
                      <img
                        [src]="
                          UPLOAD_FILE_ICONS[file.formattedType] ||
                          UPLOAD_FILE_ICONS[(file.type && file.type.toLowerCase()) || 'file']
                        "
                        draggable="false"
                        alt="file icon"
                      />
                    }
                    <app-button class="delete-file-button" btnType="icon" (onChangeClick)="deleteFile(i)">
                      <app-icon>delete</app-icon>
                    </app-button>
                  </div>
                }
              </div>
              <mat-divider></mat-divider>
            }

            <div class="input-wrapper">
              <app-button btnType="icon" [cdkMenuTriggerFor]="emoji">
                <app-icon>mood</app-icon>
              </app-button>
              <ng-template #emoji>
                <emoji-mart (emojiSelect)="addEmoji($event)" [showPreview]="false" [darkMode]="false" [isNative]="true">
                </emoji-mart>
              </ng-template>

              <textarea
                #chatInput
                [ngClass]="{ 'hidden-scroll': baseService.isMobile }"
                class="crm-scroll"
                [formControl]="textControl"
                (keydown.enter)="pressEnter($event)"
                (keydown.meta.enter)="pressCmdEnter($event)"
                (keydown.control.enter)="pressCmdEnter($event)"
                (keydown.shift.enter)="pressShiftEnter($event)"
                (keydown.arrowUp)="pressArrowUp($event)"
                (keydown.escape)="pressEscape($event)"
                appTextareaAutoresize
                name="message"
                placeholder="{{ 'write_a_message' | translate }}..."
              >
              </textarea>

              @if (!voiceActive && messageAction.action !== SEND_ACTION_TYPE.EDIT) {
                @if (lastClickAction) {
                  <app-button
                    btnType="icon"
                    (onChangeClick)="lastClickAction.action()"
                    [disabled]="chatService.isLoaderChat.input_actions"
                    matTooltip="{{ lastClickAction.title | translate }}"
                  >
                    @if (lastClickAction.is_svg) {
                      <app-icon [svgIcon]="lastClickAction.icon" />
                    } @else {
                      <app-icon>{{ lastClickAction.icon }}</app-icon>
                    }
                  </app-button>
                }

                <app-button btnType="icon" [cdkMenuTriggerFor]="menu">
                  <app-icon>add_2</app-icon>
                </app-button>
              }

              @if (voiceActive) {
                <span class="recording-state">{{ voiceFacade.formattedTime }}/5:00</span>
              }
            </div>
          </div>

          @if (voiceActive) {
            <app-button class="cancel-btn" btnType="icon" (onChangeClick)="cancelVoiceNow()">
              <app-icon>delete</app-icon>
            </app-button>
            <app-button
              class="send-btn"
              btnType="icon"
              [disabled]="loaders.send_voice"
              (onChangeClick)="sendVoiceNow()"
            >
              <app-icon>send</app-icon>
            </app-button>
          }

          @if (!voiceActive) {
            @if (isVoiceMessageButton) {
              <app-button class="send-btn" (onChangeClick)="recordVoiceMessage()" btnType="icon">
                <app-icon>mic</app-icon>
              </app-button>
            } @else {
              <app-button class="send-btn" (onChangeClick)="sendMessage(chat.id)" btnType="icon">
                <app-icon>send</app-icon>
              </app-button>
            }
          }
        </div>
      }
    </div>
  }
</div>

<ng-template #menu>
  <div class="context-menu" cdkMenu>
    @for (button of chatMenuButtons; track $index) {
      @if (!button.disabled?.()) {
        <button
          class="context-menu-item menu-button"
          cdkMenuItem
          [disabled]="chatService.isLoaderChat.input_actions"
          (click)="saveLastItem(button); button.action()"
        >
          @if (!button.is_svg) {
            <app-icon class="text-black">{{ button.icon }}</app-icon>
          } @else {
            <app-icon class="d-flex text-black" [svgIcon]="button.icon"></app-icon>
          }
          <span class="menu-title text-black">{{ button.title | translate }}</span>
        </button>
      }
    }
  </div>
</ng-template>

<ng-template #chatMenu>
  <div class="chat-context-menu" cdkMenu>
    @for (item of menuButtons; track $index) {
      @if (isMenuButtonVisible(item)) {
        <div (click)="item.action()" [ngClass]="{ divider: item.divider }" cdkMenuItem class="context-menu-item">
          <app-icon class="text-black">{{ item.icon }}</app-icon>
          <span class="menu-title text-black">{{ item.title | translate }}</span>
        </div>
      }
    }
  </div>
</ng-template>

<ng-template #groupsMessagesTemplate let-groups="groups" let-isPinned="isPinned" let-isDelayed="isDelayed">
  @for (group of groups; track group.date) {
    <div class="message-group gap-2">
      @if (isToday(group.date)) {
        <div class="message-date">{{ 'today' | translate }}</div>
      } @else if (isYesterday(group.date)) {
        <div class="message-date">{{ 'yesterday' | translate }}</div>
      } @else {
        <div class="message-date">{{ group.date }}</div>
      }

      @if (group.messages) {
        @for (message of group.messages; track message.id) {
          @if (message.type_message === MESSAGE_TYPES.SYSTEM) {
            <div class="flex justify-center">
              <div
                class="max-w-[80%] rounded-full bg-black/10 px-3 py-1 text-center text-xs text-[var(--text-color)] break-words"
              >
                {{ message.text | translate: message.x_data?.params }}
              </div>
            </div>
          } @else {
            <app-chat-message
              [id]="message.id"
              [message]="message"
              class="chat-message"
              [isDelayed]="isDelayed"
              [isPinned]="isPinned"
              (onEditMessage)="onEditMessage($event)"
              (onSendMessage)="onResendMessage($event)"
              (onReply)="onReply($event)"
            />
          }
        }
      }
    </div>
  }
</ng-template>
